// Catálogo de permisos autorizables del backend
// Para habilitar un permiso nuevo: agregar la entrada tambien en el backend y
// botón/candado en la pantalla correspondiente.

// tipoValor: qué input de valor debe pedir ModalAutorizacion antes de dejar
// pedir la autorización (undefined = sin valor, ej. aprobar orden de compra).

export const PERMISOS_AUTORIZABLES = {
  precioUnitario: {
    permisoId: "68a0b80d4319162f78ce641b",
    etiqueta: "Modificar precio unitario",
    tipoValor: "moneda",
  },
  descuento: {
    permisoId: "68a0b80d4319162f78ce641c",
    etiqueta: "Modificar descuento",
    tipoValor: "moneda|porcentaje",
  },
  listaPrecios: {
    permisoId: "68a0b80d4319162f78ce6420",
    etiqueta: "Modificar lista de precios",
    tipoValor: "seleccion",
  },
  aprobarOrdenCompra: {
    permisoId: "6a13c3f22a586012f040fe34",
    etiqueta: "Aprobar órdenes de compra",
  },
};

export const definicionPorPermisoId = (permisoId) =>
  Object.values(PERMISOS_AUTORIZABLES).find(
    (p) => p.permisoId === permisoId?.toString()
  );

export const etiquetaPorPermisoId = (permisoId) =>
  definicionPorPermisoId(permisoId)?.etiqueta || "";
